var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9658 23.3846H9.46582C8.57071 23.3846 7.71227 23.0291 7.07934 22.3961C6.4464 21.7632 6.09082 20.9047 6.09082 20.0096V9.50964C6.09082 8.61454 6.4464 7.75609 7.07934 7.12316C7.71227 6.49022 8.57071 6.13464 9.46582 6.13464H19.9658C20.8609 6.13464 21.7194 6.49022 22.3523 7.12316C22.9852 7.75609 23.3408 8.61454 23.3408 9.50964V20.0096C23.3408 20.9047 22.9852 21.7632 22.3523 22.3961C21.7194 23.0291 20.8609 23.3846 19.9658 23.3846Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34082 4.63464H19.3977C19.1643 3.9771 18.7333 3.40787 18.1636 3.00503C17.5939 2.60219 16.9135 2.38549 16.2158 2.38464H5.71582C4.82071 2.38464 3.96227 2.74022 3.32933 3.37316C2.6964 4.00609 2.34082 4.86454 2.34082 5.75964V16.2596C2.34166 16.9574 2.55837 17.6377 2.9612 18.2074C3.36404 18.7771 3.93328 19.2082 4.59082 19.4415V8.38464C4.59082 7.39008 4.98591 6.43625 5.68917 5.73299C6.39243 5.02973 7.34626 4.63464 8.34082 4.63464Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.dbf279ff.svg";
export { ForwardRef as ReactComponent };